import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import { ArrowRight } from 'gatsby-theme-pdv/src/components/icons';
import Event from '../../../layouts/event';

const UpcomingEvents = () => {
  const { futureEvents } = useStaticQuery(graphql`
    query PdVEventQuery {
      futureEvents: allWpAgenda(
        filter: {
          status: { eq: "publish" }
          isInFuture: { eq: true }
        },
        sort: { iSO8601date: ASC }
        limit: 3
      ) {
        edges {
          node {
            id
            ...Event
          }
        }
      }
    }
  `);

  return (
    <Container small>
      <Title>
        <span>Komende events</span>
        <Link to="/events">Bekijk alle events <ArrowRight /></Link>
      </Title>
      {futureEvents.edges.map(({ node }) => (
        <Event key={node.id} {...node} />
      ))}
    </Container>
  );
};

export default UpcomingEvents;

const Title = styled.h2`
  margin: 0 0 30px 0;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  span {
    display: block;
    font-family: ${(props) => props.theme.standoutFontFamily};
    font-size:  2rem;
    text-transform: uppercase;
  }
  a {
    font-size: 1rem;
    text-transform: none;
    color: ${(props) => props.theme.secondaryColor};
    text-decoration: none;
    font-weight: normal;
    &:hover {
      svg {
        margin-left: 8px;
      }
    }
    svg {
      margin-left: 4px;
      width: .4rem;
      vertical-align: middle;
      transition: margin-left .2s;
    }
  }
`;
